<page-heading [title]="'contact.view.pageTitle' | translate"
  [description]="'contact.view.pageDescription' | translate" />

@if(!loadingContent) {
<div class="d-flex flex-wrap justify-content-between g-2">
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
    <card-graphic-small-component [label]="'contact.view.totalNotes' | translate" [total]="totalNotes.toString()">
    </card-graphic-small-component>
  </div>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
    <card-graphic-small-component [label]="'contact.view.totalTags' | translate" [total]="totalTags.toString()">
    </card-graphic-small-component>
  </div>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
    <card-graphic-small-component [label]="'contact.view.attendances' | translate" [total]="countAttendance.toString()">
    </card-graphic-small-component>
  </div>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
    <card-graphic-small-component [label]="'contact.view.customFields' | translate" [total]="(customFieldsView.length || 0).toString()"
      class="w-full w-min-[50px]">
    </card-graphic-small-component>
  </div>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
    <card-graphic-small-component [label]="'contact.view.totalGroups' | translate" [total]="(contact?.groups?.length || 0).toString()">
    </card-graphic-small-component>
  </div>
</div>

<!--
  The lead markings are no longer shown here: they moved to the CUSTOMER on 2026-08-21,
  because marking a lead is enrichment and enrichment belongs to its CRM record. The
  badges now live on the customers list, next to the name.
-->
}

<ul class="nav nav-tabs nav-bordered my-3" role="tablist">
  <li class="nav-item" role="presentation">
    <a type="button" id="notes-tab" class="nav-link" [class.active]="navType === 'notes'"
      (click)="changeNavType('notes')" role="tab" aria-controls="notes" [attr.aria-selected]="navType === 'notes'">
      <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabNotes' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a type="button" id="tags-tab" class="nav-link" [class.active]="navType === 'tags'" (click)="changeNavType('tags')"
      role="tab" aria-controls="tags" [attr.aria-selected]="navType === 'tags'">
      <i class="mdi mdi-tag-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabTags' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a type="button" id="attendances-tab" class="nav-link" [class.active]="navType === 'attendances'"
      (click)="changeNavType('attendances')" role="tab" aria-controls="attendances"
      [attr.aria-selected]="navType === 'attendances'">
      <i class="mdi mdi-message-text-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabAttendances' | translate }}</span>
    </a>
  </li>

  <li class="nav-item" role="presentation">
    <a type="button" id="custom-fields-tab" class="nav-link" [class.active]="navType === 'customFields'"
      (click)="changeNavType('customFields')" role="tab" aria-controls="custom-fields"
      [attr.aria-selected]="navType === 'customFields'">
      <i class="mdi mdi-format-list-bulleted d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabCustomFields' | translate }}</span>
    </a>
  </li>

  <li class="nav-item" role="presentation">
    <a type="button" id="group-tab" class="nav-link" [class.active]="navType === 'group'"
      (click)="changeNavType('group')" role="tab" aria-controls="group" [attr.aria-selected]="navType === 'group'">
      <i class="mdi mdi-account-group-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabContactGroups' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a type="button" id="lead-source-tab" class="nav-link" [class.active]="navType === 'leadSource'"
      (click)="changeNavType('leadSource')" role="tab" aria-controls="lead-source"
      [attr.aria-selected]="navType === 'leadSource'">
      <i class="mdi mdi-map-marker-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabLeadSource' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a type="button" id="portfolio-tab" class="nav-link" [class.active]="navType === 'portfolio'"
      (click)="changeNavType('portfolio')" role="tab" aria-controls="portfolio"
      [attr.aria-selected]="navType === 'portfolio'">
      <i class="mdi mdi-wallet-outline d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'contact.view.tabCustomerPortfolio' | translate }}</span>
    </a>
  </li>
</ul>

<div class="card-body">
  <div class="row g-3 align-items-stretch">
    <div class="col-12 col-lg-8">
      <div class="card h-100">
        <div class="card-body d-flex flex-column">
          <div class="tab-content flex-grow-1" id="tabComponentsContent">
            @switch (navType) { @case ('notes') {
            <div class="tab-pane show active custom-scrollbar h-100" id="notes" role="tabpanel"
              aria-labelledby="notes-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.notesManagementTitle' | translate }}</h4>
                  <span class="">
                    {{ 'contact.view.notesManagementDescription' | translate }}
                  </span>
                </div>
                <button type="button" class="btn btn-info fw-bold ms-auto" (click)="openNoteDialog()">
                  <i class="ri-add-line"></i>
                  <span class="d-none d-md-inline">{{ 'contact.view.addNote' | translate }}</span>
                </button>
              </div>

              @if (!loadingContent && !pager.list?.length) {
              <empty-records-component class="mt-4" [message]="'contact.view.noNotesFound' | translate"
                [icon]="'mdi mdi-alert-circle-outline'" [subMessage]="
                  'contact.view.noNotesFoundSubMessage' | translate
                " />
              } @if (loadingContent) {
              <div class="card-body">
                <content-loading-list />
              </div>
              } @if (!loadingContent && pager.total > 0) {
              <div class="card-body table-responsive">
                <table class="table table-hover table-centered mb-0">
                  <thead>
                    <tr>
                      <th class="text-primary-emphasis">{{ 'contact.view.colCreatedAt' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'contact.view.colNote' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'contact.view.colUser' | translate }}</th>
                      <th class="sr-only"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (note of pager.list; track note) {
                    <tr>
                      <td>
                        <span>
                          {{
                          note.createdAt
                          | timezoneDate
                          : "DD/MM/YYYY"
                          : getTimezoneCompanyCurrentUser()
                          }}
                        </span>
                      </td>
                      <td>
                        <span>{{
                          note.description || "Sem descrição" | truncate : 50
                          }}</span>
                      </td>
                      <td>
                        <span>{{ note.user?.name }}</span>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end">
                          <button class="btn btn-dropdown-list" [matMenuTriggerFor]="menu" type="button"
                            (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                            <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                          </button>

                          <mat-menu #menu="matMenu">
                            @if (note.attendance) {
                            <button mat-menu-item tabindex="0" (click)="
                                openAttendanceNote(
                                  note.attendance._id,
                                  note.attendance.status
                                )
                              ">
                              {{ 'contact.view.goToAttendance' | translate }}
                            </button>
                            }
                            <button mat-menu-item tabindex="0" (click)="
                                openNoteDialog(note); $event.stopPropagation()
                              ">
                              {{ 'contact.view.view' | translate }}
                            </button>
                            <button mat-menu-item tabindex="0" (click)="
                                removeNote(note); $event.stopPropagation()
                              ">
                              {{ 'contact.view.remove' | translate }}
                            </button>
                          </mat-menu>
                        </div>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>

                @if (pager.total > pager.perPage) {
                <paginator [pager]="pager" (onPager)="loadPage($event)" />
                }
              </div>
              }
            </div>
            } @case ('tags') {
            <div class="tab-pane show active custom-scrollbar h-100" id="tags" role="tabpanel"
              aria-labelledby="tags-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.tagsManagementTitle' | translate }}</h4>
                  <span class="">
                    {{ 'contact.view.tagsManagementDescription' | translate }}
                  </span>
                </div>
              </div>
              <div class="col-lg-12 mb-3">
                <label class="form-label">{{ 'contact.view.tagsLabel' | translate }}</label>
                <mat-select class="form-control" (selectionChange)="selected($event)">
                  @for (item of availableTags; track item._id) {
                  <mat-option [value]="item._id">{{ item.title }}</mat-option>
                  }
                </mat-select>

                @if (selectedTags.length === 0) {
                <empty-records-component class="mt-3" [message]="'contact.view.noTagsFound' | translate"
                  [icon]="'mdi mdi-alert-circle-outline'" [subMessage]="'contact.view.noTagsFoundSubMessage' | translate" />
                }
                @for (tag of selectedTags; track tag._id) {
                <div class="d-inline-flex align-items-center mt-3 me-1">
                  <!-- bgColor is optional: without a fallback class the badge rendered
                       white-on-white, hiding both the title and the delete icon. -->
                  <span class="badge font-14 d-flex align-items-center gap-1"
                    [class.bg-secondary]="!tag.bgColor"
                    [ngStyle]="{ 'background-color': tag.bgColor || null, color: (tag.bgColor | readableText) }">
                    {{ tag.title }}
                    <i class="ri-delete-bin-5-line text-light" (click)="removeTag(tag)" style="cursor: pointer"></i>
                  </span>
                </div>
                }
              </div>
            </div>
            } @case ('attendances') {
            <div class="tab-pane show active custom-scrollbar h-100" id="attendances" role="tabpanel"
              aria-labelledby="attendances-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.attendancesManagementTitle' | translate }}</h4>
                  <span class="">{{ 'contact.view.attendancesManagementDescription' | translate }}</span>
                </div>
              </div>
              <contact-view-attendance-list-component [idContact]="$safeNavigationMigration(contact?._id)" />
            </div>
            } @case ('customFields') {
            <div class="tab-pane show active custom-scrollbar h-100" id="custom-fields" role="tabpanel"
              aria-labelledby="custom-fields-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.customFieldsManagementTitle' | translate }}</h4>
                  <span class="">
                    {{ 'contact.view.customFieldsManagementDescription' | translate }}
                  </span>
                </div>
                <button type="button" class="btn btn-info fw-bold ms-auto" (click)="addCustomField()">
                  <i class="ri-add-line"></i>
                  <span class="d-none d-md-inline">{{ 'contact.view.newField' | translate }}</span>
                </button>
              </div>

              @for (field of customFieldsView; track $index) {
              <div>
                <div class="row align-items-stretch">
                  <div class="col-lg-5">
                    <label class="form-label">{{ 'contact.view.nameLabel' | translate }}</label>
                    <mat-select class="form-control" [(ngModel)]="field.name" (selectionChange)="
                        onCustomFieldChange($index, $event.value)
                      ">
                      @for (option of fieldOptions; track option) {
                      <mat-option [value]="option" [disabled]="isFieldSelected(option, $index)">{{ option
                        }}</mat-option>
                      }
                    </mat-select>
                  </div>
                  <div class="col-lg-5">
                    <label class="form-label">{{
                      field.name || "Valor"
                      }}</label>
                    <input class="form-control" [(ngModel)]="field.value" [placeholder]="'contact.view.enterValuePlaceholder' | translate" />
                  </div>
                  <div class="col-lg-2 text-center" style="margin-top: 2rem">
                    <i (click)="removeCustomField($index)" class="ri-delete-bin-5-line text-danger fs-3"
                      style="cursor: pointer"></i>
                  </div>
                </div>
              </div>
              } @if (customFieldsView.length > 0) {
              <button class="mt-3 btn btn-primary fw-bold" (click)="saveCustomFields()" [disabled]="loading">
                @if(loading) {
                <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
                } @else { {{ 'contact.view.saveFields' | translate }} }
              </button>
              } @if (customFieldsView.length === 0) {
              <empty-records-component class="mt-3" [icon]="'mdi mdi-alert-circle-outline'"
                [message]="'contact.view.noCustomFieldsFound' | translate"
                [subMessage]="'contact.view.noCustomFieldsFoundSubMessage' | translate" />
              }
            </div>
            } @case ('group') {
            <div class="tab-pane show active custom-scrollbar h-100" id="group" role="tabpanel"
              aria-labelledby="group-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.groupsManagementTitle' | translate }}</h4>
                  <span class="">
                    {{ 'contact.view.groupsManagementDescription' | translate }}
                  </span>
                </div>
              </div>

              <div class="col-lg-12 mb-3">
                <label class="form-label">{{ 'contact.view.groupsLabel' | translate }}</label>
                <mat-select class="form-control" (selectionChange)="addGroup($event.value)">
                  @for (item of originalGroups; track item) {
                  <mat-option [value]="item">{{ item.name }}</mat-option>
                  }
                </mat-select>

                @if (contact?.groups?.length === 0) {
                <empty-records-component class="mt-3" [message]="'contact.view.noGroupsFound' | translate"
                  [icon]="'mdi mdi-alert-circle-outline'" [subMessage]="'contact.view.noGroupsFoundSubMessage' | translate" />
                } @for (group of contact.groups; track group) {
                <div class="d-inline-flex align-items-center mt-3 me-1">
                  <div class="d-flex align-items-center g-1 border rounded" style="width: fit-content">
                    <img src="../../../assets/images/logo-icon-sidebar.png" alt="{{ group.name }}"
                      class="img-fluid avatar-sm" />
                    <span class="text-muted fs-5 fw-bold">{{
                      group.name
                      }}</span>
                    <i (click)="removeGroup(group)" class="ri-close-line text-danger fs-3" style="cursor: pointer"></i>
                  </div>
                </div>
                }
              </div>

              @if (contact?.groups?.length > 0) {
              <div class="mt-3 d-flex justify-content-end">
                <button class="mt-3 btn btn-primary fw-bold" (click)="saveContact(contact)" [disabled]="loading">
                  @if(loading) {
                  <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
                  } @else { {{ 'contact.view.save' | translate }} }
                </button>
              </div>
              }
            </div>
            } @case ('leadSource') {
            <div class="tab-pane show active custom-scrollbar h-100" id="lead-source" role="tabpanel"
              aria-labelledby="lead-source-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.leadSourceManagementTitle' | translate }}</h4>
                  <span class="">
                    {{ 'contact.view.leadSourceManagementDescription' | translate }}
                  </span>
                </div>
              </div>

              <form [formGroup]="formGroup">
                <div class="col-lg-12 mb-3">
                  <mat-select class="form-control" formControlName="leadSource" [placeholder]="'contact.view.selectPlaceholder' | translate" #leadSource
                    (selectionChange)="onSelectLeadSource($event)">
                    <div class="m-1">
                      <input class="form-control" type="text" [formControl]="filterControlLeadSource"
                        [placeholder]="'contact.view.searchLeadSourcePlaceholder' | translate" />
                    </div>
                    @for (item of listLeadSource; track item) {
                    <mat-option [value]="item">{{
                      item?.name + " (" + item?.channel?.name + ")"
                      }}</mat-option>
                    }
                  </mat-select>

                  @if (contact?.leadSource?.name) {
                  <div class="d-flex align-items-center g-2 border rounded py-2 px-4 mt-3" style="width: fit-content">
                    <span class="fs-5 fw-bold text-muted">{{ 'contact.view.originLabel' | translate }}</span>
                    <span class="text-dark fs-5 fw-bold">{{ contact?.leadSource.name }}</span>
                  </div>
                  } @if (isLeadSourceSelected) {
                  <div class="mt-3 d-flex justify-content-end">
                    <button class="mt-3 btn btn-primary fw-bold" (click)="saveLeadSource(leadSourceSelected)">
                      {{ 'contact.view.save' | translate }}
                    </button>
                  </div>
                  } @if (!isLeadSourceSelected &&
                  !contact?.leadSource?.name) {
                  <empty-records-component class="mt-4" [message]="'contact.view.noLeadSource' | translate"
                    [icon]="'mdi mdi-alert-circle-outline'" [subMessage]="
                      'contact.view.noLeadSourceSubMessage' | translate
                    " />
                  }
                </div>
              </form>
            </div>
            } @case ('portfolio') {
            <div class="tab-pane show active custom-scrollbar h-100" id="portfolio" role="tabpanel"
              aria-labelledby="portfolio-tab">
              <div class="d-flex align-items-start g-2 mb-3">
                <div>
                  <h4 class="mb-1 fs-4">{{ 'contact.view.portfolioManagementTitle' | translate }}</h4>
                  <span class="">
                    {{ 'contact.view.portfolioManagementDescription' | translate }}
                  </span>
                </div>
              </div>

              <form [formGroup]="formGroup">
                <div class="col-lg-12 mb-3">
                  <label class="form-label">{{ 'contact.view.departmentLabel' | translate }}</label>
                  <mat-select class="form-control" formControlName="department" [placeholder]="'contact.view.selectDepartmentPlaceholder' | translate"
                    (focus)="onFocusDepartments()" #department (selectionChange)="changeDepartment()">
                    @for (item of allDepartments; track item) {
                    <mat-option [value]="item._id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                  <field-error-component [field]="'department'" [label]="'contact.view.departmentLabel' | translate" [formGroup]="formGroup" />
                </div>

                <div class="col-lg-12 mb-3">
                  <label class="form-label">{{ 'contact.view.attendantLabel' | translate }}</label>
                  <mat-select class="form-control" formControlName="attendant" [placeholder]="'contact.view.selectAttendantPlaceholder' | translate"
                    (focus)="onFocusAttendant()" #department>
                    @for (item of allAttendant; track item) {
                    <mat-option [value]="item._id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                  <field-error-component [field]="'attendant'" [label]="'contact.view.attendantLabel' | translate" [formGroup]="formGroup" />
                </div>

                <div class="mt-3 d-flex justify-content-end">
                  <button class="mt-3 btn btn-primary fw-bold" [disabled]="!formGroup.valid"
                    (click)="saveContact(contact)">
                    @if(loading) {
                    <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
                    } @else { {{ 'contact.view.save' | translate }} }
                  </button>
                </div>
              </form>
            </div>
            } }
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-4">
      <div class="card h-100">
        <div class="card-body p-0">
          <div class="d-flex align-items-center p-3 border-bottom">
            <div class="avatar placeholder me-3 rounded-circle">
              <img [src]="contact.image" alt="image user" class="img-fluid avatar-sm rounded-circle"
                (error)="onImageError($event)" />
            </div>
            <div class="flex-grow-1">
              <div class="d-flex align-items-center flex-wrap">
                <h6 class="mb-0 fs-5 fw-bold">{{ contact.name }}</h6>
                @if(!isEditMode) {
                <span class="badge text-capitalize font-14 mb-2 ms-3" [ngClass]="{
                    'bg-success': contact?.valid === 'VALIDATED',
                    'bg-warning': contact?.valid === 'NOT_VALIDATED',
                    'bg-danger': contact?.valid === 'INVALID'
                  }">
                  {{ getContactStatus($safeNavigationMigration(contact?.valid)) }}
                </span>
                }
              </div>
              @if(contact?.createdAt) {
              <small class="text-muted d-block">
                {{ 'contact.view.createdOn' | translate }}
                {{
                $safeNavigationMigration(contact?.createdAt)
                | timezoneDate
                : "DD/MM/YYYY"
                : getTimezoneCompanyCurrentUser()
                }}
              </small>
              }
            </div>

            @if(!isEditMode) {
            <div class="d-flex justify-content-end">
              <button class="btn btn-dropdown-list" [matMenuTriggerFor]="menu" type="button"
                (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item tabindex="0" (click)="editContact(contact); $event.stopPropagation()">
                  {{ 'contact.view.edit' | translate }}
                </button>

                @if(isAdmin() || isSupervisor()) {
                <button mat-menu-item tabindex="0" (click)="delete(contact); $event.stopPropagation()"
                >
                  {{ 'contact.view.remove' | translate }}
                </button>
                }
              </mat-menu>
            </div>
            } @else {
            <div class="d-flex align-items-center gap-2 ms-auto">
              <button class="btn btn-primary" (click)="saveContact(contact)">
                {{ 'contact.view.save' | translate }}
              </button>
              <button class="btn btn-outline-secondary" (click)="cancelEdit()">
                {{ 'contact.view.cancel' | translate }}
              </button>
            </div>
            }
          </div>

          <div class="p-3">
            <ul class="list-unstyled mb-0 small lead-list g-3 fs-5" [ngClass]="{
                'text-secondary': isEditMode,
                'text-muted': !isEditMode
              }">


              @if (contact?.whatsapp?.bsuid) {
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  @if ((isAttendant() &&
                  !getCurrentUserUser()?.clientVisibilitys) || (isSupervisor()
                  || isAdmin())) {

                  <i class="ri-whatsapp-line me-2 text-muted"></i>
                  <strong>{{ 'contact.view.bsuidWhatsappLabel' | translate }}</strong>
                  <span class="text-muted ms-1"> {{ contact?.whatsapp?.bsuid ?? "-" }} </span>
                  }
                </p>
              </li>
              }
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  @if ((isAttendant() &&
                  !getCurrentUserUser()?.clientVisibilitys) || (isSupervisor()
                  || isAdmin())) {

                  <i class="ri-phone-line me-2 text-muted"></i>
                  <strong>{{ 'contact.view.phoneLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.phone ?? "-" }}
                  </span>
                  } @else {
                  <input type="text" pattern="[0-9]*" inputmode="numeric"
                    class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.phone" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                  } }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-user-line me-2 text-muted"></i><strong>{{ 'contact.view.nameFieldLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.name ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.name" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-mail-line me-2 text-muted"></i><strong>{{ 'contact.view.emailLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.email ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.email" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0 text-muted">
                  <i class="ri-compass-3-line me-2 text-muted"></i><strong>{{ 'contact.view.leadSourceFieldLabel' | translate }}</strong>
                  <span class="text-muted ms-1">
                    {{ contact?.leadSource?.name ?? '-' }}
                  </span>
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-building-4-line me-2 text-muted"></i><strong>{{ 'contact.view.companyLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.contactCompany ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.contactCompany" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-briefcase-4-line me-2 text-muted"></i><strong>{{ 'contact.view.positionLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.contactPosition ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.contactPosition" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-id-card-line me-2 text-muted"></i><strong>{{ 'contact.view.cpfLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{
                    contact?.tin
                    ? (contact.tin | mask : "000.000.000-00")
                    : "-"
                    }}
                  </span>
                  } @else {
                  <input [mask]="'000.000.000-00'" type="text" pattern="[0-9]*" inputmode="numeric"
                    class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.tin" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-map-pin-line me-2 text-muted"></i><strong>{{ 'contact.view.zipLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{
                    contact?.zip ? (contact.zip | mask : "00000-000") : "-"
                    }}
                  </span>
                  } @else {
                  <input [mask]="'00000-000'" type="text" pattern="[0-9]*" inputmode="numeric"
                    class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.zip" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-road-map-line me-2 text-muted"></i><strong>{{ 'contact.view.addressLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.address ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.address" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-community-line me-2 text-muted"></i><strong>{{ 'contact.view.cityLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.city ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.city" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-map-2-line me-2 text-muted"></i><strong>{{ 'contact.view.stateLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{ contact?.state ?? "-" }}
                  </span>
                  } @else {
                  <input class="bg-transparent w-100 border-0 border-bottom rounded-0 shadow-none"
                    [(ngModel)]="editedContact.state" inputmode="text" (input)="onStateInput($event)" />
                  }
                </p>
              </li>
              <li class="mb-2">
                <p class="d-flex align-items-center mb-0">
                  <i class="ri-cake-2-line me-2 text-muted"></i><strong>{{ 'contact.view.birthDateLabel' | translate }}</strong>
                  @if(!isEditMode) {
                  <span class="text-muted ms-1">
                    {{
                    ($safeNavigationMigration(contact?.birthDate)
                    | timezoneDate
                    : "DD/MM/YYYY"
                    : getTimezoneCompanyCurrentUser()) ?? "-"
                    }}
                  </span>
                  } @else {
                  <input class="form-control" [matDatepicker]="picker" readonly [(ngModel)]="editedContact.birthDate"
                    (keydown)="$event.preventDefault()" (focus)="picker.open()" [max]="today"
                    placeholder="00/00/0000" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  }
                </p>
              </li>
            </ul>
          </div>

          <div class="text-center">
            <button class="btn btn-primary rounded-pill btn-lg px-4" (click)="openNewConversation()">
              <i class="ri-customer-service-2-line"></i>
              {{ !loading ? ('contact.view.startAttendance' | translate) : "" }}

              @if(loading) {
              <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
